// extracted by mini-css-extract-plugin
module.exports = {"tooltipWrap":"tooltipWrap__e-RxSIbfvP85i","tooltipText":"tooltipText__8RuGciGB5L954"};